import CountUpBase from 'react-countup'

/**
 * Thin wrapper around CountUp that coerces invalid `end` values to 0.
 * (Kept for call-site compatibility; the native shim also tolerates NaN.)
 */
export default function SafeCountUp({ end, ...props  }) {
  const safeEnd =
    end == null || Number.isNaN(Number(end)) ? 0 : Number(end)
  return <CountUpBase {...props} end={safeEnd} />
}
